import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lory } from 'lory.js';

import { randomizer } from 'Utils';
import Dots from './Dots';

const HeaderWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  display: ${({ showMobile }) => (showMobile ? 'block' : 'none')};
  /* border-radius: ${({ showMobile }) => (showMobile ? 0 : '5px')}; */
  &:hover {
    .lory-arrow-left,
    .lory-arrow-right {
      transform: translateX(0);
    }
  }

  ${props => props.theme.breakpoints.up('lg')} {
    display: block;
  }
`;

const Slider = styled.div`
  border-radius: ${({ showMobile }) => (showMobile ? 0 : '5px')};
`;

const Frame = styled.div`
  width: 100%;
  position: relative;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  white-space: nowrap;
  /* border-radius: ${({ showMobile }) => (showMobile ? 0 : '5px')}; */
`;

const Slides = styled.div`
  display: inline-block;
  width: 100%;
  border-radius: ${({ showMobile }) => (showMobile ? 0 : '5px')};
`;

const Slide = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  border-radius: ${({ showMobile }) => (showMobile ? 0 : '5px')};
`;

class SliderHeaderV3 extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    showMobile: PropTypes.bool,
  };

  static defaultProps = {
    showMobile: false,
  };

  state = {
    mounted: false,
  };

  componentDidMount() {
    const slider = document.querySelector('.js_slider');

    this.sliderInstance = lory(slider, { rewind: true, rewindPrev: false });
    window.sliderInstance = this.sliderInstance;
    if (window.innerWidth >= 1024 || this.props.showMobile) {
      this.setAutoPlay();
      this.setState({ mounted: true });
    }
  }

  componentDidUpdate() {
    if (this.dotsInstace && this.sliderInstance) {
      this.sliderInstance.setup();
      this.dotsInstace.goTo(0)();
    }
  }

  setAutoPlay = () => {
    this.sliderInterval = setInterval(() => this.sliderInstance.next(), 5000);
  };

  onMouseOver = () => {
    clearInterval(this.sliderInterval);
  };

  render() {
    const { mounted } = this.state;
    const { children, showMobile } = this.props;
    const bannersLength = React.Children.toArray(children).length;

    return (
      <HeaderWrapper
        onMouseOver={this.onMouseOver}
        onMouseOut={this.setAutoPlay}
        showMobile={showMobile}
      >
        <Slider className="js_slider" showMobile={showMobile}>
          <Frame className="js_frame" showMobile={showMobile}>
            <Slides className="js_slides" showMobile={showMobile}>
              {React.Children.toArray(children).map(child => (
                <Slide showMobile={showMobile} key={randomizer.getString()}>
                  {child}
                </Slide>
              ))}
            </Slides>
          </Frame>
        </Slider>
        {/*
          :HACK-ALERT:
          Dots component should mount after SliderHeaderV3 mount if not
          Dots component can't access to this.dotsInstace
          (See the componentDidMount implementation)
        */}
        {mounted && bannersLength > 1 && (
          <Dots
            length={bannersLength}
            headerInstance={this}
            ref={dotsInstace => {
              this.dotsInstace = dotsInstace;
            }}
          />
        )}
      </HeaderWrapper>
    );
  }
}

export default SliderHeaderV3;
